import numeral from 'numeral';

const keys = (isDark, t) => [
    {
        key: 'impressions',
        label: t('discover.overview.summaryChart.impressions'),
        icon: 'search',
        img: isDark ? '/static/img/file-search_dark.svg' : '/static/img/file-search.svg',
    },
    {
        key: 'ctr',
        label: t('discover.overview.summaryChart.ctr'),
        format: '0.00%',
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'ctr',
        img: isDark ? '/static/img/cursor-box_dark.svg' : '/static/img/cursor-box.svg',
    },
    {
        key: 'pages',
        label: t('discover.overview.summaryChart.pages'),
        format: '0.0',
        yAxisID: 'y2',
        info: 'The number of pages that generate Google Discover traffic that day',
        icon: 'pagev-view',
        img: isDark ? '/static/img/file-05_dark.svg' : '/static/img/file-05.svg',
    },
    {
        key: 'clicks',
        label: t('discover.overview.summaryChart.clicks'),
        icon: 'clicks',
        yAxisID: 'y3',
        img: isDark ? '/static/img/cursor-click-01_dark.svg' : '/static/img/cursor-click-01.svg',
    },
];

export default keys;
